export enum permissionType {
  Authenticated = 1,
  CreateAccounts = 2,
  Provider = 3,
  AccountAdmin = 4,
  SuperAdmin = 5,
  AccountManager = 6
}

export enum UserSettingsBaseEnum {
  user_list = "user.list",
  master_vehicle_list = "master.vehicle.list",
}

export enum WhereToUpload {}

export enum DocumentTypeEnum {
  Figures = 0,
  Permits = 1,
  Logo = 2,
}

export enum ImportType {
  Tools = 1,
  Parts = 2,
  Equipments = 3,
}
